import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExternalScriptService {
  loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve();
      script.onerror = () => reject(`Script load error: ${src}`);
      document.head.appendChild(script);
    });
  }

  runMyScript(): void {
    // Your script logic here, or calls to the loaded library
    console.log('External script functionality executed.');
  }
}